export default __webpack_public_path__ + "static/woman1-8d898f6f27ec21ffd125dd80f139a1e7.png";